<template>
  <div>
    <div class="shadow" v-show="ispreorder">
      <div class="preordercode">
        <div class="close" @click="closepreorder"></div>
        <div class="codebg"></div>
        <div class="codet">扫描微信二维码</div>
        <div class="codedet">了解预订详情</div>
      </div>
    </div>
    <div class="quicknav">
      <div
        class="qnlist"
        v-for="(nav, index) in navs"
        :key="index"
        :class="{ qnactive: nav.isactive }"
        @mouseover="nav.isactive = true"
        @mouseleave="nav.isactive = currentnav == index"
        @click="scrollto(nav.navid)"
      >
        {{ nav.isactive ? nav.name : '' }}
      </div>
    </div>
    <div class="page">
      <div class="pic">
        <img src="/static/img/p1.jpg" width="100%" alt="Blueshark R Series" />
      </div>
      <div class="text t1">
        <div
          class="fs_big fw_bold color_theme t1_1 aniel"
          :class="{ ani: ani.a1 }"
        >
          Blueshark R Series
        </div>
        <div class="fs_big fw_bold t1_2 aniel" :class="{ ani1: ani.a1 }">
          智慧電動機車
        </div>
        <div class="color_gray aniel" :class="{ ani2: ani.a1 }">
          有動力 更聰明
        </div>
      </div>
      <div class="text t1a" id="a2">
        <div class="t1a_top">
          <div>
            <div class="t1a_t">
              <span :class="{ aniel: true, ani: ani.a2 }">
                <span class="fs_huge">110</span> km
              </span>
            </div>
            <div>
              <span class="color_gray aniel" :class="{ ani1: ani.a2 }">
                NEDC 續航
              </span>
            </div>
          </div>
          <div>
            <div class="t1a_t">
              <span class="t1a_1" :class="{ aniel: true, ani: ani.a2 }">
                <span class="fs_huge">80</span> km/h
              </span>
            </div>
            <div>
              <span class="color_gray aniel" :class="{ ani1: ani.a2 }">
                極速
              </span>
            </div>
          </div>
          <div>
            <div class="t1a_t">
              <span class="t1a_1" :class="{ aniel: true, ani: ani.a2 }">
                <span class="fs_normal">動⼒ + 係統控製域</span>
              </span>
            </div>
            <div>
              <span class="color_gray aniel" :class="{ ani1: ani.a2 }">
                汽⾞級雙域智慧型中控系統
              </span>
            </div>
          </div>
          <div>
            <div class="t1a_t">
              <span class="t1a_1" :class="{ aniel: true, ani: ani.a2 }">
                <span class="fs_normal">ArkRide</span>
                <span class="fs_normal">OS 2.0</span>
              </span>
            </div>
            <div>
              <span class="color_gray aniel" :class="{ ani1: ani.a2 }">
                Blueshark ⾞載智慧型操作系統
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Robor -->
    <div class="page" id="n1" v-show="false">
      <div class="pic">
        <img
          src="/static/img/p2.jpg"
          width="100%"
          alt="蓝鲨 R 系列 智能电动摩托车"
        />
      </div>
      <div class="text t2" id="a3">
        <div class="aniel" :class="{ ani: ani.a3 }">
          <img src="/static/img/Robor.png" width="130px" alt="" />
        </div>
        <div class="fs_normal content aniel t2_2" :class="{ ani1: ani.a3 }">
          一台运用汽车科技创造的<br />智能电动摩托车
        </div>
      </div>
    </div>
    <!-- 动力 -->
    <div class="page" id="n2">
      <swiper3 ref="swiper3"></swiper3>
      <div class="text normalt t3a" id="a31">
        <div class="fs_big t3_1 aniel" :class="{ ani: ani.a31 }">
          洶湧<span class="fs_big color_theme">動力</span> 澎湃前行
        </div>
        <div class="fs_normal color_gray t3_2 aniel" :class="{ ani1: ani.a31 }">
          汽車級高速馬達 扭力大功率足
        </div>
      </div>
    </div>
    <div class="page" id="s4">
      <swiper4></swiper4>
      <div class="text t4" id="a4">
        <div class="fs_big1 title aniel" :class="{ ani: ani.a4 }">
          前後協力 左右同心
        </div>
        <div class="content aniel" :class="{ ani1: ani.a4 }">
          騎車快，剎車也要穩。CBS
          前後聯動雙碟剎系統高效縮短制動距離，拉動左右任意一側制動手柄，前後輪碟剎器隨即同時進入工作狀態，均衡分配制動力，在高效減速的同時不失平穩。
        </div>
      </div>
    </div>
    <!-- 操控 -->
    <div class="page" id="n3">
      <div class="pic">
        <img
          src="/static/img/p5.jpg"
          width="100%"
          alt="蓝鲨 R 系列汽车级电机控制器"
        />
      </div>
      <div class="text t5" id="a5">
        <div class="fs_big t5_1 aniel" :class="{ ani: ani.a5 }">
          全面佈<span class="color_theme fs_big">局</span> 車隨心動
        </div>
        <div class="fs_normal color_gray t5_2 aniel" :class="{ ani1: ani.a5 }">
          汽車級馬達控制器 五段變速系統自由騎行
        </div>
        <div class="content aniel" :class="{ ani2: ani.a5 }">
          為了充分发揮側掛電機的強大性能，我們為 Blueshark R Series
          裝載汽車級大功率馬達控制器，其架構設計、節能化、輕量化和品質均達到汽車級標準。在弱磁控制和電流前饋控制算法的加持下，輔以
          FOC 向量控制系統的調節，SVPWM
          空間向量脈寬調制系統精確輸出控制訊號，使整車在保持平順駕駛體驗的同時，突破動力系統性能的邊界。
        </div>
      </div>
    </div>
    <div class="page">
      <div class="pic">
        <img src="/static/img/p6.jpg" width="100%" alt="蓝鲨 R 系列六挡行车" />
      </div>
      <div class="text t6" id="a6">
        <div class="fs_big1 title aniel" :class="{ ani: ani.a6 }">
          五段變速 ⼀觸即得
        </div>
        <div class="content aniel" :class="{ ani1: ani.a6 }">
          Blueshark R Series 擁有 3 個常規模式、移⾞助⼒模式、和 Turbo 競速模式*
          。<br />在電機控制器的精準調節下，<br />Blueshark R Series
          同時支援在任意速度下實現汽車級定速巡航，<br />讓騎乘用戶享受如呼吸般自由舒適的騎乘體驗。
        </div>
      </div>
      <div class="text t6a" id="a33">
        <div class="fs_tiny color_gray aniel" :class="{ ani: ani.a33 }">
          * 僅可在雙電池組同時運行且剩餘電量均大於 20% 的狀態下啟動
        </div>
      </div>
    </div>
    <!-- 续航 -->
    <div class="page" id="n4">
      <div class="pic">
        <img
          src="/static/img/p7.jpg"
          width="100%"
          alt="蓝鲨 R 系列双锂电 支持160km续航"
        />
      </div>
      <div class="text t7" id="a7">
        <div class="t7_left">
          <div class="fs_big t7_1 aniel" :class="{ ani: ani.a7 }">
            雙<span class="fs_big color_theme">電</span>齊下 源源不斷
          </div>
          <div
            class="fs_normal color_gray t7_2 aniel"
            :class="{ ani1: ani.a7 }"
          >
            汽車級雙鋰電 持久續航電壓倍增
          </div>
          <div class="content aniel" :class="{ ani2: ani.a7 }">
            Blueshark R Series
            的座桶內可容納兩顆汽⾞級⾼能量密度鋰電池組（48V/30Ah
            ×2），⼀般騎⾏狀態下最⾼可達 110km 的 NEDC 續航裡程。
            防摔防刺⼀體成型鋁合⾦外桶的防⽕阻燃和散熱性能得到⼤幅提升，保障電池在極端條件下安全無虞。
          </div>
          <!-- <div class="t7_4 aniel" :class="{ani3: ani.a7}">
            <span class="color_gray">￥<span class="fs_big color_theme">5988</span> / 雙電</span>
          </div> -->
        </div>
        <div class="t7_right">
          <div class="t7_3 aniel" :class="{ ani: ani.a7 }">
            <span class="fs_middle">2880</span> Wh<br /><span class="fs_tiny">
              雙鋰電池總容量
            </span>
          </div>
          <div class="t7_3 aniel" :class="{ ani1: ani.a7 }">
            <span class="fs_middle">110</span> km<br /><span class="fs_tiny">
              NEDC 續航裡程
            </span>
          </div>
          <div class="aniel" :class="{ ani2: ani.a7 }">
            <span class="fs_middle">&lt; 3.5</span> h<br />
            <span class="fs_tiny">
              單電快充所需時間
            </span>
          </div>
        </div>
      </div>
      <div id="a8" class="text t7a">
        <!-- <div class="fs_tiny aniel" :class="{ani: ani.a8}">*在骑乘者体重 75 kg，行驶速度 30 km/h，环境温度为 25℃ 等实验室条件下计算所得理论数据</div> -->
      </div>
    </div>
    <div class="page">
      <div class="t8">
        <div id="a9" class="title fs_big1 aniel" :class="{ ani: ani.a9 }">
          BMS 智慧型電池管理系統
        </div>
        <div class="t8a">
          <div class="t8a_item">
            <div id="a10" class="t8a_1 color_gray">
              <span class="aniel" :class="{ ani: ani.a10 }"
                ><img
                  src="/static/img/p8-11.png"
                  alt="蓝鲨 R 系列电池管理系统"/></span
              ><br /><span class="fs_tiny aniel" :class="{ ani1: ani.a10 }">
                預放電
              </span>
            </div>
            <div id="a11" class="t8a_1 color_gray">
              <span class="aniel" :class="{ ani: ani.a11 }">
                <img
                  src="/static/img/p8-21.png"
                  alt="蓝鲨 R 系列电池管理系统"
                />
              </span>
              <br /><span class="fs_tiny aniel" :class="{ ani1: ani.a11 }">
                強弱電隔離保護
              </span>
            </div>
            <div id="a12" class="color_gray">
              <span class="aniel" :class="{ ani: ani.a12 }"
                ><img
                  src="/static/img/p8-31.png"
                  alt="蓝鲨 R 系列电池管理系统"/></span
              ><br /><span class="fs_tiny aniel" :class="{ ani1: ani.a12 }"
                >過充保護</span
              >
            </div>
          </div>
          <div class="t8a_item">
            <div class="t8a_1 color_gray">
              <span class="aniel" :class="{ ani: ani.a10 }">
                <img
                  src="/static/img/p8-12.png"
                  alt="蓝鲨 R 系列电池管理系统"
                />
              </span>
              <br /><span class="fs_tiny aniel" :class="{ ani1: ani.a10 }">
                電壓均衡
              </span>
            </div>
            <div class="t8a_1 color_gray">
              <span class="aniel" :class="{ ani: ani.a11 }"
                ><img
                  src="/static/img/p8-22.png"
                  alt="蓝鲨 R 系列电池管理系统"/></span
              ><br /><span class="fs_tiny aniel" :class="{ ani1: ani.a11 }"
                >防水設計</span
              >
            </div>
            <div class="color_gray">
              <span class="aniel" :class="{ ani: ani.a12 }"
                ><img
                  src="/static/img/p8-32.png"
                  alt="蓝鲨 R 系列电池管理系统"/></span
              ><br /><span class="fs_tiny aniel" :class="{ ani1: ani.a12 }"
                >過放保護</span
              >
            </div>
          </div>
          <div class="t8a_item">
            <div class="t8a_1 color_gray">
              <span class="aniel" :class="{ ani: ani.a10 }"
                ><img
                  src="/static/img/p8-13.png"
                  alt="蓝鲨 R 系列电池管理系统"/></span
              ><br /><span class="fs_tiny aniel" :class="{ ani1: ani.a10 }"
                >充放電循環次數統計</span
              >
            </div>
            <div class="t8a_1 color_gray">
              <span class="aniel" :class="{ ani: ani.a11 }"
                ><img
                  src="/static/img/p8-23.png"
                  alt="蓝鲨 R 系列电池管理系统"/></span
              ><br /><span class="fs_tiny aniel" :class="{ ani1: ani.a11 }"
                >斷線保護</span
              >
            </div>
            <div class="color_gray">
              <span class="aniel" :class="{ ani: ani.a12 }"
                ><img
                  src="/static/img/p8-33.png"
                  alt="蓝鲨 R 系列电池管理系统"/></span
              ><br /><span class="fs_tiny aniel" :class="{ ani1: ani.a12 }"
                >非接觸式通訊</span
              >
            </div>
          </div>
          <div class="t8a_item">
            <div class="t8a_1 color_gray">
              <span class="aniel" :class="{ ani: ani.a10 }"
                ><img
                  src="/static/img/p8-14.png"
                  alt="蓝鲨 R 系列电池管理系统"/></span
              ><br /><span class="fs_tiny aniel" :class="{ ani1: ani.a10 }"
                >雙電池放電管理</span
              >
            </div>
            <div class="t8a_1 color_gray">
              <span class="aniel" :class="{ ani: ani.a11 }"
                ><img
                  src="/static/img/p8-24.png"
                  alt="蓝鲨 R 系列电池管理系统"/></span
              ><br /><span class="fs_tiny aniel" :class="{ ani1: ani.a11 }"
                >短路保護</span
              >
            </div>
            <div class="color_gray">
              <span class="aniel" :class="{ ani: ani.a12 }"
                ><img
                  src="/static/img/p8-34.png"
                  alt="蓝鲨 R 系列电池管理系统"/></span
              ><br /><span class="fs_tiny aniel" :class="{ ani1: ani.a12 }"
                >電池故障二次保護</span
              >
            </div>
          </div>
          <div class="t8a_item">
            <div class="t8a_1 color_gray">
              <span class="aniel" :class="{ ani: ani.a10 }"
                ><img
                  src="/static/img/p8-15.png"
                  alt="蓝鲨 R 系列电池管理系统"/></span
              ><br /><span class="fs_tiny aniel" :class="{ ani1: ani.a10 }"
                >雙電池充電管理</span
              >
            </div>
            <div class="t8a_1 color_gray">
              <span class="aniel" :class="{ ani: ani.a11 }"
                ><img
                  src="/static/img/p8-25.png"
                  alt="蓝鲨 R 系列电池管理系统"/></span
              ><br /><span class="fs_tiny aniel" :class="{ ani1: ani.a11 }"
                >過流保護</span
              >
            </div>
            <div class="color_gray">
              <span class="aniel" :class="{ ani: ani.a12 }"
                ><img
                  src="/static/img/p8-35.png"
                  alt="蓝鲨 R 系列电池管理系统"/></span
              ><br /><span class="fs_tiny aniel" :class="{ ani1: ani.a12 }"
                >溫度保護</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page">
      <div class="pic">
        <img src="/static/img/p9.jpg" width="100%" alt="蓝鲨电压倍增技术" />
      </div>
      <div class="text normalt" id="a13">
        <div class="title fs_big1 aniel" :class="{ ani: ani.a13 }">
          乘奔禦風 急速騎行
        </div>
        <div class="content aniel" :class="{ ani1: ani.a13 }">
          Blueshark
          技術團隊自主研發電壓倍增技術，並聯狀態下均衡輸出電流，串聯狀態下觸發雙倍電壓，後者即
          Turbo 競速檔* 的高速行車模式。<br />這項技術是電源管理系統技術上的重大突破，引領高速電摩發展新方向。
        </div>
      </div>
      <div id="a32" class="text t9a">
        <div class="fs_tiny color_gray aniel" :class="{ ani: ani.a32 }">
          * 僅可在雙電池組同時運行且剩餘電量均大於 20% 的狀態下啟動
        </div>
      </div>
    </div>
    <div class="page">
      <swiper10></swiper10>
      <div class="text normalt" id="a14">
        <div class="title fs_big1 aniel" :class="{ ani: ani.a14 }">
          多場景快充
        </div>
        <div class="content aniel" :class="{ ani1: ani.a14 }">
          Blueshark R Series
          支援在各種環境下進行充電——無論是家庭用電環境還是電動車充電環境。<br />單顆電池最快僅需
          3.5 小時即可充滿，從此無需再為續航煩惱。
        </div>
      </div>
    </div>
    <!-- 设计 -->
    <div class="page" id="n5">
      <swiper11></swiper11>
      <div class="text t11" id="a15">
        <div class="fs_big aniel" :class="{ ani: ani.a15 }">
          獨樹一幟 <span class="fs_big color_theme">蔚</span>然成風
        </div>
        <div
          class="fs_normal color_gray t15_2 aniel"
          :class="{ ani1: ani.a15 }"
        >
          汽車級工業設計 自由而嚴謹 簡潔而醒目
        </div>
      </div>
    </div>
    <!-- 品质 -->
    <div class="page" id="n6">
      <div class="pic">
        <img
          src="/static/img/p12-tw.jpg"
          width="100%"
          alt="蓝鲨 R 系列与贝纳利摩托共厂生产制造|顶级供应链合作伙伴|整车承重 200 kg"
        />
      </div>
      <div class="text normalt" id="a16">
        <div class="title fs_big aniel" :class="{ ani: ani.a16 }">
          匠心獨運 精益求<span class="fs_big color_theme">精</span>
        </div>
        <div class="content aniel" :class="{ ani1: ani.a16 }">
          Blueshark R Series
          的車架、殼體、燈具、避震、剎車、輪胎等核心部件，均與全球知名機車零部件品牌合作，<br />以競賽級摩托車的工藝和品管標準精心打造智慧型電動機車
        </div>
      </div>
      <div class="text t12" id="a34">
        <div class="fs_tiny t12_1 aniel" :class="{ ani: ani.a34 }">
          一線大型機車廠生產制造
        </div>
        <!-- <div class="fs_tiny t12_2 aniel" :class="{ani: ani.a34}"></div> -->
        <div class="fs_tiny t12_3 aniel" :class="{ ani: ani.a34 }">
          整車承重 200 kg
        </div>
      </div>
    </div>
    <!-- 智能 -->
    <div class="page" id="n7">
      <div class="pic">
        <img src="/static/img/p13.jpg" width="100%" alt="蓝鲨 R 系列汽车科技" />
      </div>
      <div class="text normalt" id="a17">
        <div class="title fs_big aniel" :class="{ ani: ani.a17 }">
          汽車科技 <span class="fs_big color_theme">智</span>慧降臨
        </div>
      </div>
    </div>
    <div class="page">
      <div class="pic">
        <img
          src="/static/img/p14.jpg"
          width="100%"
          alt="蓝鲨 R 系列智能中控系统"
        />
      </div>
      <div class="text normalt" id="a18">
        <div class="title fs_big1 aniel" :class="{ ani: ani.a18 }">
          「動⼒控製域 + 系統控製域」雙域智慧型中控系統
        </div>
        <div class="content aniel" :class="{ ani1: ani.a18 }">
          在技術團隊深耕多年的基礎上，我們⾃主研發汽⾞級『動⼒控製域 +
          系統控製域』雙域智慧型中控系統。<br />動⼒控製域可以即時智慧調控⾏⾞狀態，系統控制域負責⼈機交互。<br />使得整⾞的功能擴展性⼤幅增強，可實現添加其他功能模組的定製化需求。
        </div>
      </div>
    </div>
    <div class="page">
      <swiper15></swiper15>
      <div class="text normalt" id="a19">
        <div class="title fs_big1 aniel" :class="{ ani: ani.a19 }">
          10 英⼨全彩⾼解析 IPS 螢幕
        </div>
        <div class="content aniel" :class="{ ani1: ani.a19 }">
          Blueshark R Series 搭載 G+G 全貼合 10 英⼨超寬全彩⾼解析 IPS
          螢幕，搭載⾃研的 ArkRide OS 2.0 智慧型操作系統，<br />⽀援 GPS + 北⽃
          + 4G 三模定位導航，藍⽛⾳樂、OTA
          升級等功能，帶來靈敏⽽便捷的智慧操控體驗。
        </div>
      </div>
    </div>
    <div class="page">
      <div class="pic">
        <img
          src="/static/img/p16.jpg"
          width="100%"
          alt="蓝鲨 R 系列AI里程预估"
        />
      </div>
      <div class="text normalt" id="a20">
        <div class="title fs_big1 aniel" :class="{ ani: ani.a20 }">
          AI 里程預測
        </div>
        <div class="content aniel" :class="{ ani1: ani.a20 }">
          綜合剩餘電量、環境溫度、行駛速度和整車重量等參數，Blueshark R Series
          在雲端和本地即時進行動態計算，為你顯示當前行駛狀態下的剩餘里程。
        </div>
      </div>
    </div>
    <div class="page">
      <div class="lisablack hp0" id="a21">
        <!-- <div class="title fs_big1 aniel" :class="{ani: ani.a21}">「你好, Lisa」</div>
        <div class="content aniel" :class="{ani1: ani.a21}">和智能骑行伴侣 Lisa 打个招呼，定向收音麦克风确保你的讯息准确无误传达。<br/>一句「你好, Lisa」,让你的旅程不再孤独。</div> -->
      </div>
      <div class="pic">
        <!-- <video src="/static/img/lisa.mp4" width="100%" autoplay="autoplay" loop="loop" muted="muted"></video> -->
      </div>
    </div>
    <!-- <div class="page">
      <div class="lisablack" id="a21">
        <div class="title fs_big1 aniel" :class="{ani: ani.a21}">「你好, Lisa」</div>
        <div class="content aniel" :class="{ani1: ani.a21}">和智能骑行伴侣 Lisa 打个招呼，定向收音麦克风确保你的讯息准确无误传达。<br/>一句「你好, Lisa」,让你的旅程不再孤独。</div>
      </div>
      <div class="pic">
        <video src="/static/img/lisa.mp4" width="100%" autoplay="autoplay" loop="loop" muted="muted"></video>
      </div>
    </div> -->
    <div class="page">
      <div class="pic">
        <img src="/static/img/en17.jpg" width="100%" alt="Blueshark APP" />
      </div>
      <div class="text normalt" id="a22">
        <div class="title fs_big1 aniel" :class="{ ani: ani.a22 }">
          Blueshark APP
        </div>
        <div class="content aniel" :class="{ ani1: ani.a22 }">
          車輛資訊即時與雲端互動，並同步到手機 App 中。<br />定位查詢、遠端控制、行車統計、電池檢測、整車體檢，隨時一手掌握。
        </div>
      </div>
    </div>
    <div class="page">
      <div class="pic">
        <img
          src="/static/img/p18.jpg"
          width="100%"
          alt="蓝鲨 R 系列配备72枚传感器"
        />
      </div>
      <div class="text normalt" id="a23">
        <div class="title fs_big1 aniel" :class="{ ani: ani.a23 }">
          70+ 枚智慧型感測器
        </div>
        <div class="content aniel" :class="{ ani1: ani.a23 }">
          70+
          枚感測器遍布車身，隨時獲取包括速度、加速度、角速度、溫度、環境光、水位和座墊壓力等多重行車資訊，<br />提供整車智慧化數據支援，幫助
          Blueshark R Series 保持最佳的騎行狀態。
        </div>
      </div>
    </div>
    <div class="page">
      <div class="pic">
        <img
          src="/static/img/p19.jpg"
          width="100%"
          alt="蓝鲨 R 系列双向移车助力"
        />
      </div>
      <div class="text normalt" id="a24">
        <div class="title fs_big1 aniel" :class="{ ani: ani.a24 }">
          移⾞助⼒模式 (MAM)
        </div>
        <div class="content aniel" :class="{ ani1: ani.a24 }">
          當你進⼊移⾞助⼒模式時，轉動⼿把或向左撥動模式切換鍵，可提供步⾏速度向前移動，向右撥動模式切換鍵，⾞⼦緩速向後移動。便捷操作助⼒輕鬆移⾞。
        </div>
      </div>
    </div>
    <div class="page">
      <swiper20></swiper20>
      <div class="text normalt" id="a25">
        <div class="title fs_big1 aniel" :class="{ ani: ani.a25 }">
          ADAS 安全駕駛輔助系統
        </div>
        <div class="content aniel" :class="{ ani1: ani.a25 }">
          汽⾞級 ADAS 智慧駕駛輔助係統即時監控⾏⾞狀況，通知提醒可即時呈現，<br />⽤⼾也可以通過⼿機端
          App 隨時取得相關資訊。
        </div>
      </div>
    </div>
    <!-- 安全 -->
    <div class="page" id="n8">
      <swiper21 ref="swiper21"></swiper21>
      <div class="text normalt" id="a26">
        <div class="fs_big aniel" :class="{ ani: ani.a26 }">
          千方百计 万无一失
        </div>
        <div
          class="fs_normal color_gray t21_2 aniel"
          :class="{ ani1: ani.a26 }"
        >
          全⽅位安全保障 汽⾞級藍⽛智慧鑰匙系統 + 無感⾃動解鎖
        </div>
      </div>
    </div>
    <div class="page" id="s22">
      <swiper22 ref="swiper22"></swiper22>
    </div>
    <div class="page" id="s23">
      <swiper23 ref="swiper23"></swiper23>
    </div>
    <div class="page p24">
      <div id="a27">
        <div class="title fs_big1 aniel" :class="{ ani: ani.a27 }">
          技術參數
        </div>
        <div class="t24p aniel" :class="{ ani1: ani.a27 }">
          <div>
            <img
              src="/static/img/p24-1-tw.png"
              width="100%"
              alt="蓝鲨 R 系列技术参数"
            />
          </div>
        </div>
        <div class="t24">
          <div class="feature" id="a28">
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a28 }"
                >額定最大承載重量</span
              ><br /><span class="aniel" :class="{ ani1: ani.a28 }"
                >200 kg</span
              >
            </div>
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a28 }"
                >車體重量(含電池)</span
              ><br /><span class="aniel" :class="{ ani1: ani.a28 }"
                >115 kg</span
              >
            </div>
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a28 }"
                >車身顏色</span
              ><br /><span class="aniel" :class="{ ani1: ani.a28 }"
                >秋月白；雲墨黑；綠如藍；鬆濤綠；椰林棕</span
              >
            </div>
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a28 }"
                >啟動方式</span
              ><br /><span class="aniel" :class="{ ani1: ani.a28 }"
                >藍牙感應</span
              >
            </div>
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a28 }"
                >中控儀表</span
              ><br /><span class="aniel" :class="{ ani1: ani.a28 }"
                >10''全彩高解析 IPS 螢幕</span
              >
            </div>
          </div>
          <div class="feature" id="a29">
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a29 }"
                >智慧操作係統</span
              ><br /><span class="aniel" :class="{ ani1: ani.a29 }"
                >ArkRide OS</span
              >
            </div>
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a29 }"
                >電池容量</span
              ><br /><span class="aniel" :class="{ ani1: ani.a29 }"
                >1,440*2 Wh</span
              >
            </div>
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a29 }"
                >NEDC 續航裡程</span
              ><br /><span class="aniel" :class="{ ani1: ani.a29 }"
                >110 km
              </span>
            </div>
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a29 }"
                >極速</span
              ><br /><span class="aniel" :class="{ ani1: ani.a29 }"
                >80 km/h</span
              >
            </div>
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a29 }"
                >馬達峰值功率</span
              ><br /><span class="aniel" :class="{ ani1: ani.a29 }"
                >5,000W</span
              >
            </div>
          </div>
          <div class="feature" id="a30">
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a30 }"
                >馬達最高轉速</span
              ><br /><span class="aniel" :class="{ ani1: ani.a30 }"
                >5,500 rpm</span
              >
            </div>
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a30 }"
                >智慧中控系統</span
              ><br /><span class="aniel" :class="{ ani1: ani.a30 }"
                >動力+系統控制域</span
              >
            </div>
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a30 }"
                >ADAS 智慧駕駛輔助系統</span
              ><br /><span class="aniel" :class="{ ani1: ani.a30 }"
                >後攝像頭+雙超聲探頭 <br />
                （前攝像頭選裝）</span
              >
            </div>
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a30 }"
                >剎車系統</span
              ><br /><span class="aniel" :class="{ ani1: ani.a30 }"
                >CBS 前後同步雙碟剎</span
              >
            </div>
            <div class="featureitem fs_tiny">
              <span
                class="fs_tiny color_gray aniel"
                :class="{ ani: ani.a30 }"
              ></span
              ><br /><span class="aniel" :class="{ ani1: ani.a30 }"></span>
            </div>
            <!-- <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ani: ani.a30}">语音助手</span><br/><span class="aniel" :class="{ani1: ani.a30}">Lisa 骑行伴侣</span></div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import swiper3 from '../swiper_tw/swiper3'
import swiper4 from '../swiper_tw/swiper4'
import swiper10 from '../swiper_tw/swiper10'
import swiper11 from '../swiper_tw/swiper11'
import swiper15 from '../swiper_tw/swiper15'
import swiper20 from '../swiper_tw/swiper20'
import swiper21 from '../swiper_tw/swiper21'
import swiper22 from '../swiper_tw/swiper22'
import swiper23 from '../swiper_tw/swiper23'
import { throttle } from 'lodash'
export default {
  data() {
    return {
      ani: {
        a1: false,
        a2: false,
        a3: false,
        a4: false,
        a5: false,
        a6: false,
        a7: false,
        a8: false,
        a9: false,
        a10: false,
        a11: false,
        a12: false,
        a13: false,
        a14: false,
        a15: false,
        a16: false,
        a17: false,
        a18: false,
        a19: false,
        a20: false,
        a21: false,
        a22: false,
        a23: false,
        a24: false,
        a25: false,
        a26: false,
        a27: false,
        a28: false,
        a29: false,
        a30: false,
        a31: false,
        a32: false,
        a33: false,
        a34: false
      },
      navs: [
        { name: 'R Series', isactive: false, navid: 'n1' },
        { name: '動力', isactive: false, navid: 'n2' },
        { name: '操控', isactive: false, navid: 'n3' },
        { name: '續航', isactive: false, navid: 'n4' },
        { name: '設計', isactive: false, navid: 'n5' },
        { name: '品質', isactive: false, navid: 'n6' },
        { name: '智慧', isactive: false, navid: 'n7' },
        { name: '安全', isactive: false, navid: 'n8' }
      ],
      currentnav: -1,
      ispreorder: false
      // aniarr: ["a1","a2","a3"]
    }
  },
  components: {
    swiper3,
    swiper4,
    swiper10,
    swiper11,
    swiper15,
    swiper20,
    swiper21,
    swiper22,
    swiper23
  },
  mounted() {
    window.scrollTo(0, 0)
    this.$nextTick(() => {
      window.addEventListener(
        'scroll',
        throttle(this.animateTxt, 500, { leading: true })
      )
    })
    setTimeout(() => {
      this.ani.a1 = true
    }, 300)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.animateTxt)
  },
  methods: {
    preorder() {
      this.ispreorder = true
    },
    closepreorder() {
      this.ispreorder = false
    },
    checkconfig() {
      this.$router.push('/config')
    },
    getscrolltop(id) {
      let obj = document.getElementById(id)
      if (obj) {
        let top = obj.offsetTop
        while ((obj = obj.offsetParent)) {
          top += obj.offsetTop
        }
        return top
      }
    },
    scrollto(id) {
      window.scrollTo(0, this.getscrolltop(id))
    },
    setnavs() {
      for (let i in this.navs) {
        this.navs[i].isactive = false
      }
    },
    animateTxt() {
      let top =
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.pageYOffset
      // let width = document.body.clientWidth
      let height = document.body.clientHeight
      if (top <= 100) {
        this.$emit('hidenav')
      } else {
        this.$emit('shownav')
      }
      // 左侧快速导航
      for (let i = 0; i < 9; i++) {
        let prev = i > 0 ? this.getscrolltop('n' + i) : 0
        let next = i < 8 ? this.getscrolltop('n' + (i + 1)) : 1000000
        if (top >= prev && top < next) {
          this.setnavs()
          if (i > 0) {
            this.navs[i - 1].isactive = true
          }
          this.currentnav = i - 1 // 锁定当前页
          break
        }
      }
      // 每一页文字出现特效
      for (let i = 2; i < 35; i++) {
        if (
          top > this.getscrolltop('a' + i) - height + 200 &&
          top < this.getscrolltop('a' + i)
        ) {
          this.ani['a' + i] = true
        }
      }
      if (
        top > this.getscrolltop('n2') - height + 200 &&
        top < this.getscrolltop('n2')
      ) {
        if (this.$refs.swiper3) {
          this.$refs.swiper3.startani1()
        }
      }
      if (
        top > this.getscrolltop('s4') - height &&
        top < this.getscrolltop('s4') - 300
      ) {
        if (this.$refs.swiper3) {
          this.$refs.swiper3.startani2()
        }
      }
      if (
        top > this.getscrolltop('n8') - height + 200 &&
        top < this.getscrolltop('n8')
      ) {
        if (this.$refs.swiper21) {
          this.$refs.swiper21.startani()
        }
      }
      if (
        top > this.getscrolltop('s22') - height + 200 &&
        top < this.getscrolltop('s22')
      ) {
        if (this.$refs.swiper22) {
          this.$refs.swiper22.startani()
        }
      }
      if (
        top > this.getscrolltop('s23') - height + 200 &&
        top < this.getscrolltop('s23')
      ) {
        if (this.$refs.swiper23) {
          this.$refs.swiper23.startani()
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/common.less';
.subscript {
  display: inline-block;
  font-size: 10px;
  vertical-align: top;
  position: relative;
  top: -4px;
  transform: scale(0.8);
}
.quicknav {
  position: fixed;
  left: 0;
  top: 30vh;
  color: #fff;
  z-index: 100;
  .qnlist {
    padding-left: 40px;
    position: relative;
    cursor: pointer;
    width: 150px;
    height: 30px;
  }
  .qnlist::before {
    position: absolute;
    content: '';
    width: 15px;
    height: 0;
    border-top: 1px solid #666;
    top: 10px;
    left: 15px;
  }
  .qnactive::before {
    position: absolute;
    content: '';
    width: 30px;
    height: 0;
    border-top: 1px solid #fff;
    top: 10px;
    left: 0;
  }
}
.shadow {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 300;
  .preordercode {
    padding-top: 40px;
    width: 340px;
    height: 300px;
    text-align: center;
    background: #fff;
    // background: url(/static/img/p28_1.jpg);
    // background-size: cover;
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    .codebg {
      margin: 0 auto;
      width: 200px;
      height: 200px;
      background: url(/static/img/p28_1.jpg);
      background-size: cover;
    }
    .codet {
      color: #999;
      // padding: 5px 0 10px;
      margin-bottom: 10px;
    }
    .codedet {
      font-size: 24px;
    }
    .close {
      width: 20px;
      height: 20px;
      position: absolute;
      top: 20px;
      right: 20px;
      cursor: pointer;
    }
    .close::before {
      content: '';
      position: absolute;
      top: 10px;
      left: -4px;
      width: 26px;
      height: 0;
      border-top: 1px solid #666;
      transform: rotate(45deg);
    }
    .close::after {
      content: '';
      position: absolute;
      top: 10px;
      left: -4px;
      width: 26px;
      height: 0;
      border-top: 1px solid #666;
      transform: rotate(-45deg);
    }
  }
}
.page {
  position: relative;
  background-color: #000;
  .pic {
    font-size: 0;
  }
  .lisablack {
    background-color: #000;
    height: 8vw;
    color: #fff;
    text-align: center;
    padding-top: 4vw;
  }
  .hp0 {
    height: 0;
    padding-top: 0;
  }
  .title {
    margin-bottom: 26px;
  }
  .content {
    line-height: 24px;
  }
  .content1 {
    line-height: 20px;
  }
  .text {
    position: absolute;
    z-index: 1;
    color: #fff;
  }
  .t1 {
    text-align: center;
    left: 0;
    top: 0;
    margin: 160px auto;
    right: 0;
    .t1_1 {
      margin-bottom: 5px;
    }
    .t1_2 {
      margin-bottom: 15px;
    }
  }
  .t1a {
    bottom: 80px;
    margin: 0 auto;
    left: 0;
    right: 0;
    width: 70%;
    .t1a_top {
      display: flex;
      display: -webkit-flex;
      justify-content: space-around;
      text-align: center;
      width: 100%;
      .t1a_t {
        height: 50px;
        line-height: 50px;
        vertical-align: text-bottom;
      }
      .subscript {
        position: relative;
        top: -5px;
        font-size: 14px;
      }
    }
    .t1a_bottom {
      width: 100%;
      color: #999;
      font-size: 12px;
      text-align: center;
      margin-top: 30px;
    }
  }
  .t2 {
    left: 18vw;
    top: 9vw;
    line-height: 60px;
    .t2_2 {
      line-height: 36px;
    }
  }
  .t3a {
    .t3_2 {
      margin: 15px auto 0;
    }
  }
  .t4 {
    left: 9vw;
    top: 15vw;
    width: 440px;
    text-align: justify;
  }
  .t5 {
    left: 12vw;
    top: 15vw;
    width: 410px;
    text-align: justify;
    .t5_1 {
      margin-bottom: 10px;
    }
    .t5_2 {
      margin-bottom: 20px;
    }
  }
  .normalt {
    top: 65px;
    left: 0;
    right: 0;
    margin: 0 auto;
    text-align: center;
  }
  .t6 {
    top: 22vw;
    left: 0;
    right: 0;
    margin: 0 auto;
    text-align: center;
  }
  .t6a {
    text-align: center;
    bottom: 5vw;
    width: 100%;
  }
  .t7 {
    left: 7vw;
    top: 11vw;
    right: 17vw;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    .t7_left {
      width: 400px;
      text-align: justify;
      padding-top: 2vw;
    }
    .t7_1 {
      margin-bottom: 10px;
    }
    .t7_2 {
      margin-bottom: 20px;
    }
    .t7_3 {
      margin-bottom: 40px;
    }
    .t7_4 {
      margin-top: 40px;
    }
  }
  .t7a {
    left: 0;
    right: 0;
    margin: 0 auto;
    bottom: 3vw;
    font-size: 10px;
    text-align: center;
    color: @colorgray;
  }
  .t8 {
    background-color: #000;
    color: #fff;
    text-align: center;
    padding: 4vw 0;
    .t8a {
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      width: 60%;
      margin: 80px auto 0;
      .t8a_item {
        flex: 1;
      }
      img {
        width: 50px;
        margin-bottom: 10px;
      }
      .t8a_1 {
        margin-bottom: 50px;
        height: 90px;
      }
    }
  }
  .t9a {
    width: 100%;
    text-align: center;
    bottom: 5vw;
  }
  .t11 {
    left: 10vw;
    top: 160px;
  }
  .t12 {
    display: flex;
    display: -webkit-flex;
    left: 17vw;
    right: 17vw;
    bottom: 7.5vw;
    text-align: center;
    .t12_1 {
      flex: 1;
    }
    .t12_3 {
      flex: 1;
    }
  }
  .t15_2 {
    margin: 15px auto 10px;
  }
  .t21_2 {
    margin: 15px auto 15px;
  }
  .t24p {
    padding: 2vw 18vw;
  }
  .t24 {
    margin-top: 3vw;
    .feature {
      width: 80%;
      margin: 0 auto;
      border-top: 1px solid #333;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      padding: 2vw 3vw;
      box-sizing: border-box;
      .featureitem {
        flex: 1;
        text-align: left;
        line-height: 24px;
        margin-right: 10px;
        .aniel {
          font-size: 14px;
        }
        .subscript {
          display: inline-block;
          position: relative;
          top: -2px;
          transform: scale(0.8);
        }
        .fs_tiny {
          margin-bottom: 20px;
        }
      }
    }
    .csenv {
      text-align: center;
      font-size: 14px;
      color: #999;
    }
  }
}
.p24 {
  background: url(/static/img/p24.jpg) no-repeat;
  background-size: cover;
  color: #fff;
  padding-bottom: 2vw;
  .title {
    padding-top: 4vw;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tw/product.vue